module.exports = __webpack_public_path__ + "img/logo_2.f98d702a.png";